import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';
import { useState } from 'react';
import { UserRole } from '@uplift/types';
import { useCurrentuser } from '@uplift/contexts';

const supportLinkByRole = {
  [UserRole.provider]: 'https://provider-help.joinuplift.co/contact/contact-us-ByfUGBPLR',
  [UserRole.patient]: 'https://client-help.joinuplift.co/contact/contact-us-BJMlcfnt1x',
};

const useConnectionTipsStyles = makeStyles({ name: 'connection-tips' })(theme => ({
  borderBottom: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  itemOne: {
    flexDirection: 'column',
    display: 'flex',
    gap: theme.spacing(3),
  },
  list: {
    paddingLeft: '12px',
    '& li': {
      marginBottom: theme.spacing(3),
    }
  },
  readInstructions: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      width: '177px',
    }
  }
}));

export const ConnectionTips: React.VFC = () => {
  const l10n = useL10n();
  const isMdDown = useIsMobile('md');
  const { classes } = useConnectionTipsStyles();
  const [ open, setOpen ] = useState(false);
  const me = useCurrentuser();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <Button variant="text" color="secondary" onClick={handleClick} fullWidth={isMdDown}>
        {l10n.sessions.connectionTips.havingIssues}
      </Button>
      <Modal
        open={open}
        onClose={handleClick}
        title={l10n.sessions.connectionTips.modalTitle}
        maxWidth={isMdDown ? 'sm' : 'md'}
      >
        <ModalContent className={classes.borderBottom}>
          <ol className={classes.list}>
            <li>
              <Box className={classes.itemOne}>
                <Typography>{l10n.sessions.connectionTips.hasAccess}</Typography>
                <Typography>{l10n.sessions.connectionTips.viewHelp}</Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth={isMdDown}
                  className={classes.readInstructions}
                  component="a"
                  href="https://provider-help.joinuplift.co/en_us/categories/technical-requirements-and-troubleshooting-BJqWtsvcR"
                  target="_blank"
                  rel="noreferrer"
                >
                  {l10n.sessions.connectionTips.readInstructions}
                </Button>
              </Box>
            </li>
            {isMdDown ? (
              <li>
                <Typography>
                  {l10n.sessions.connectionTips.strongInternet}
                </Typography>
              </li>

            ) : (
              <>
                <li>
                  <Typography>
                    {l10n.sessions.connectionTips.strongWifi}
                  </Typography>
                </li>
                <li>
                  <Typography>
                    {l10n.sessions.connectionTips.closeUnused}
                  </Typography>
                </li>
                <li>
                  <Typography>
                    {l10n.sessions.connectionTips.update}
                  </Typography>
                </li>
              </>
            )}
          </ol>
        </ModalContent>
        <ModalActions disableSpacing>
          <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
            <Typography color="textSecondary">
              {l10n.sessions.connectionTips.stillHavingTrouble}
            </Typography>
            <Button variant="outlined" component="a" href={supportLinkByRole[me.role] ?? `mailto:${l10n.helpEmail}`} target="_blank">
              {l10n.pages.contactSupport}
            </Button>
          </Box>
        </ModalActions>
      </Modal>
    </>
  );
};
